import {computed, toRaw} from 'vue';
import {getFieldFromData} from './dataFieldHelper';


/**
 * Composable для работы с данными полей напрямую из newData
 */
export function useDataFields(blockData: any) {
  // Создаем computed для реактивности
  // Используем toRaw для получения сырых данных, но computed все равно будет отслеживать изменения ссылки
  const data = computed(() => blockData);

  // Создаем реактивную функцию getData, которая отслеживает изменения в blockData
  const getData = (path: string) => {
    // Используем data.value для реактивности - computed будет отслеживать изменения
    // Важно: обращаемся к data.value внутри computed, чтобы Vue отслеживал зависимости
    const field = getFieldFromData(path, data.value);
    // Возвращаем data напрямую, чтобы сохранить реактивность
    // Если field.data - это реактивный объект, он будет отслеживаться
    return field?.data || {};
  };

  return {
    getData,
    data: data.value
  };
}
